import { FC } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import Iconify from '@src/components/iconify';
import { NavEntryType } from '@src/types/main';

type NavItemProps = {
  item: NavEntryType;
};

const NavItem: FC<NavItemProps> = (props) => {
  const { item } = props;

  const location = useLocation();
  const isActive = location.pathname === item.path;

  return (
    <ListItemButton
      component={NavLink}
      to={item.path}
      end
      sx={{
        py: 1.5,
        pl: 5,
        gap: 2,
        '& .MuiListItemIcon-root': {
          minWidth: 'auto',
        },
        '&.active': {
          backgroundColor: 'custom.background',
          color: 'primary.dark',
        },
      }}
    >
      <ListItemIcon>
        <Iconify
          data-testid="iconify"
          icon={item.icon}
          sx={{ color: isActive ? 'primary.dark' : 'custom.lightGrey' }}
        />
      </ListItemIcon>
      <ListItemText
        primary={item.label}
        slotProps={{
          primary: { sx: { fontFamily: 'secondaryFontFamily' } },
        }}
      />
    </ListItemButton>
  );
};

export default NavItem;
